import {
  alpha,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  useTheme,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import axiosServices from "../../../utils/axios";
import useLocalStorage from "../../../hooks/useLocalStorage";

export default function FilterSelection() {

  const filterName = "centerCode";
  const defaultFilterValues = [
    {
      title: "Tất cả",
      value: `${filterName}:ALL`,
    },
    {
      title: "Hạ Long",
      value: `${filterName}:HL`,
    },
    {
      title: "Cẩm Phả",
      value: `${filterName}:CP`,
    },
    {
      title: "Bãi Cháy",
      value: `${filterName}:BC`,
    },
    {
      title: "Uông Bí",
      value: `${filterName}:UB`,
    },
  ];
  const theme = useTheme();
  const { app, user } = useSelector((state: any) => state);
  const [filterValues, setFilterValues] = useState(defaultFilterValues);
  let [headersFilters, setHeadersFilters] = useLocalStorage("headers.filters", `${filterName}:ALL`)
  let component = <></>;
  if (user?.isLoggedin && app?.schema?.categorySelection) {
    component = (
      <FormControl fullWidth margin="normal">
        <InputLabel
          id="category-selection-label"
          color="primary"
          shrink
          variant="outlined"
          sx={{
            color: theme.palette.common.white,
            "&.Mui-focused": {
              color: theme.palette.common.white,
            },
          }}
        >
          Cơ sở
        </InputLabel>
        <Select
          labelId="category-selection-label"
          label="Cơ sở"
          variant="outlined"
          value={headersFilters}
          defaultValue={""}
          onChange={(evt) => {
            axiosServices.defaults.headers.common.filters = evt.target.value;
            setHeadersFilters(evt.target.value);
            window.location.reload();
          }}
          sx={{
            color: theme.palette.common.white,
            borderColor: theme.palette.common.white,
            backgroundColor: alpha(theme.palette.common.white, 0.15),
            "&:hover": {
              borderColor: theme.palette.common.white,
              backgroundColor: alpha(theme.palette.common.white, 0.25),
            },
          }}
        >
          {filterValues.map((item, i) => (
            <MenuItem key={i} value={item.value}>
              {item.title}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }

  useEffect(() => {
    if (headersFilters) {
      axiosServices.defaults.headers.common.filters = headersFilters;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [headersFilters]);

  return component;
}
